// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.width_1200[data-v-798c9b84] {\n  width: 1200px !important;\n}\n.width_1000[data-v-798c9b84] {\n  width: 1000px !important;\n}\n.width_1050[data-v-798c9b84] {\n  width: 1050px !important;\n}\n.width_700[data-v-798c9b84] {\n  width: 700px !important;\n}\n.width_800[data-v-798c9b84] {\n  width: 800px !important;\n}\n", ""]);
// Exports
module.exports = exports;
